/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import { apichildaccountdetail, apilogin, apiupdatechildren } from '@/api';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import GroupTitle from "vux/src/components/group-title/index.vue"; // this line is trasformed by vux-loader
import Confirm from "vux/src/components/confirm/index.vue"; // this line is trasformed by vux-loader
import UserLogo from '@/components/UserLogo';
export default {
  name: 'group-person',
  props: {
    id: [String, Number]
  },
  components: {
    ViewBox: ViewBox,
    Group: Group,
    Cell: Cell,
    UserLogo: UserLogo,
    GroupTitle: GroupTitle,
    Confirm: Confirm
  },
  data: function data() {
    return {
      showChangeName: false,
      person: {}
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user', 'pageReload'])),
  created: function created() {
    this.reload();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('globalStore', ['_ApiLogout'])), {}, {
    // 加载人员数据
    reload: function reload() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$apichildaccoun, data, success;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apichildaccountdetail({
                  id: _this.id
                });
              case 2:
                _yield$apichildaccoun = _context.sent;
                data = _yield$apichildaccoun.data;
                success = _yield$apichildaccoun.success;
                if (success) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return");
              case 7:
                _this.person = data;
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeName: function changeName(text, val) {
      var _this2 = this;
      this.showChangeName = true;
      setTimeout(function (_) {
        _this2.$refs.confirm.setInputValue(_this2.person.name);
      });
    },
    // 修改姓名
    onConfirm: function onConfirm(val) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (val) {
                  _context2.next = 3;
                  break;
                }
                _this3.$vux.toast.text(i18n.tc("483"));
                return _context2.abrupt("return");
              case 3:
                _context2.next = 5;
                return apiupdatechildren({
                  name: val,
                  id: _this3.id
                });
              case 5:
                res = _context2.sent;
                if (res.success) {
                  _this3.$vux.toast.text(i18n.tc("484"));
                  _this3.person.name = val;
                } else {
                  _this3.$vux.toast.text(res.message);
                }
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 删除人员
    deletePerson: function deletePerson() {
      var _this4 = this;
      this.$vux.confirm.show({
        title: i18n.tc("280"),
        content: i18n.tc("485"),
        hideOnBlur: true,
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var _yield$apilogin, success, message;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return apilogin({
                      id: _this4.id
                    }, 'delete');
                  case 2:
                    _yield$apilogin = _context3.sent;
                    success = _yield$apilogin.success;
                    message = _yield$apilogin.message;
                    if (success) {
                      _this4.$vux.toast.text(i18n.tc("486"));
                      _this4.$router.go(-1);
                    } else {
                      _this4.$vux.toast.text(message);
                    }
                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    },
    // 设置管理员
    setManage: function setManage() {
      var _this5 = this;
      if (this.person.is_admin === 1) return;
      this.$vux.confirm.show({
        title: i18n.tc("487"),
        content: i18n.tc("488"),
        hideOnBlur: true,
        onConfirm: function () {
          var _onConfirm2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            var _yield$apilogin2, success, message;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return apilogin({
                      id: _this5.id
                    }, 'put');
                  case 2:
                    _yield$apilogin2 = _context4.sent;
                    success = _yield$apilogin2.success;
                    message = _yield$apilogin2.message;
                    if (success) {
                      _this5.$vux.toast.text(i18n.tc("489"));
                      _this5.reload();
                    } else {
                      _this5.$vux.toast.text(message);
                    }
                  case 6:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));
          function onConfirm() {
            return _onConfirm2.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    }
  })
};